import * as React from 'react';
import { Flex } from "../../flex";
import { getToastContainerStyles } from "./ToastContainer.styles";
export var ToastContainer = function ToastContainer(_ref) {
  var children = _ref.children,
      _ref$anchorOrigin = _ref.anchorOrigin,
      anchorOrigin = _ref$anchorOrigin === void 0 ? {
    horizontal: 'right',
    vertical: 'bottom'
  } : _ref$anchorOrigin;
  var styles = getToastContainerStyles({
    anchorOrigin: anchorOrigin
  });
  return /*#__PURE__*/React.createElement(Flex, {
    sx: styles
  }, children, " ");
};